module.exports = __webpack_public_path__ + "static/media/close-icon.a594ab60.svg";